"use client";

import { pushAnalyticsEvent } from "@/lib/analytics/dataLayer";

type GA4Params = Record<string, string | number | boolean | null | undefined>;

export function trackEvent(name: string, params?: GA4Params) {
  pushAnalyticsEvent(name, params);
}

export function trackConversionLead(source: string) {
  trackEvent("generate_lead", { lead_type: "evaluation", source });
}

export function trackPageView(pagePath: string) {
  trackEvent("page_view", { page_path: pagePath });
}
